export const BOARD_DRAG_TYPES_CARD = 'Card'



// WEBPACK FOOTER //
// ./src/constants/boardDragTypes.js